/**
 * @generated SignedSource<<61ebfae7722510b2db32f767f232969d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
export type UpdateInsightInput = {
  id: string;
  name?: string | null;
  components?: ReadonlyArray<InsightComponentInputType | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type InsightComponentInputType = {
  id?: string | null;
  componentName?: string | null;
  x?: number | null;
  y?: number | null;
  w?: number | null;
  h?: number | null;
  config?: string | null;
};
export type updateInsightMutation$variables = {
  input: UpdateInsightInput;
};
export type updateInsightMutation$data = {
  readonly updateInsight: {
    readonly insight: {
      readonly id: string;
      readonly name: string | null;
      readonly components: ReadonlyArray<{
        readonly id: string;
        readonly componentName: string | null;
        readonly x: number | null;
        readonly y: number | null;
        readonly w: number | null;
        readonly h: number | null;
        readonly config: string | null;
      } | null> | null;
      readonly labels: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
      } | null> | null;
      readonly statusColumns: ReadonlyArray<{
        readonly id: string;
        readonly category: STATUS_CATEGORY | null;
        readonly name: string | null;
      } | null> | null;
      readonly clients: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type updateInsightMutation = {
  variables: updateInsightMutation$variables;
  response: updateInsightMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateInsightPayload",
    "kind": "LinkedField",
    "name": "updateInsight",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Insight",
        "kind": "LinkedField",
        "name": "insight",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightComponent",
            "kind": "LinkedField",
            "name": "components",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "componentName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "x",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "y",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "w",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "h",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "config",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "labels",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumn",
            "kind": "LinkedField",
            "name": "statusColumns",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "clients",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateInsightMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateInsightMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "5f29597ca5621e6346cd64e7e3b90c3b",
    "id": null,
    "metadata": {},
    "name": "updateInsightMutation",
    "operationKind": "mutation",
    "text": "mutation updateInsightMutation(\n  $input: UpdateInsightInput!\n) {\n  updateInsight(input: $input) {\n    insight {\n      id\n      name\n      components {\n        id\n        componentName\n        x\n        y\n        w\n        h\n        config\n      }\n      labels {\n        id\n        name\n      }\n      statusColumns {\n        id\n        category\n        name\n      }\n      clients {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4dc5acf1c14a471b2c97f29f3d5dd59b";

export default node;
